import { render } from "./wares-task.vue?vue&type=template&id=268e1adc"
import script from "./wares-task.vue?vue&type=script&lang=js"
export * from "./wares-task.vue?vue&type=script&lang=js"

import "./wares-task.vue?vue&type=style&index=0&id=268e1adc&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__